module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/inactive-customer-report/inactive-customer-report.component.scss
// module id = ./client/app/inactive-customer-report/inactive-customer-report.component.scss
// module chunks = main